import { Action } from '../../types/action.js';
import {
  RecommendationsSettings,
  RecommendationsSettingsState,
} from '../../types/Recommendations.js';
import {
  changeRecommendationsSettingsActions,
  getRecommendationsSettingsActions,
} from '../action/api/RecommendationsApi.js';

const initialState: RecommendationsSettingsState = {
  isLoading: false,
  error: '',
  objectPrioritisationGoal: null,
  objectPrioritisationOptimization: null,
  budgetReallocationLimits: null,
  mediaOverspendingEnabled: false,
  mediaOverspendingLimit: null,
  mediaUnderspendingEnabled: false,
  mediaUnderspendingLimit: null,
  otherAllowSuggestNewPlatforms: false,
  otherAllowSuggestStopPlatforms: false,
  nonApplicableList: { channels: [] },
};

const reducer = (
  state: RecommendationsSettingsState = initialState,
  action: Action<RecommendationsSettings>,
) => {
  switch (action.type) {
    case getRecommendationsSettingsActions.type.REQUEST:
    case changeRecommendationsSettingsActions.type.REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }

    case getRecommendationsSettingsActions.type.FAILED:
    case changeRecommendationsSettingsActions.type.FAILED: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    case getRecommendationsSettingsActions.type.SUCCESS:
    case changeRecommendationsSettingsActions.type.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: '',
        ...action.payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
